import { IActionBase, ITemplatePageState } from "../models/root.interface";
import { UPDATE_PAGINATION_TOTAL_TEMPLATE, UPDATE_PAGINATION_POSTS_PER_PAGE_TEMPLATE, UPDATE_PAGINATION_CURRENT_PAGE_TEMPLATE, UPDATE_LOADING_STATE_TEMPLATE, UPDATE_NOTFOUND_STATE_TEMPLATE, UPDATE_TABLE_STATE_TEMPLATE,UPDATE_SEARCH_TEMPLATE, UPDATE_SEARCH_CURRENT_PAGE_TEMPLATE, UPDATE_API_CALL_TEMPLATE } from "../actions/templatePage.action";


const initialState: ITemplatePageState = {
totalPostsTemplate: 0,  postsPerPageTemplate: 25, currentPageTemplate: 1, loadingTemplate: "block", notFoundTemplate: "none",tableTemplate:"none",searchTemplate:"",currentPageSearchTemplate:1, apiCallTemplate:false
};
function templatePageReducer(state: ITemplatePageState = initialState, action: IActionBase): ITemplatePageState {
    switch (action.type) {
        case UPDATE_PAGINATION_TOTAL_TEMPLATE:
            return { ...state, totalPostsTemplate: action.totalPostsTemplate };
        case UPDATE_PAGINATION_POSTS_PER_PAGE_TEMPLATE:
            return { ...state, postsPerPageTemplate: action.postsPerPageTemplate };
        case UPDATE_PAGINATION_CURRENT_PAGE_TEMPLATE:
            return { ...state, currentPageTemplate: action.currentPageTemplate };
        case UPDATE_LOADING_STATE_TEMPLATE:
            return { ...state,loadingTemplate: action.loadingTemplate } ;
        case UPDATE_NOTFOUND_STATE_TEMPLATE:
            return { ...state, notFoundTemplate: action.notFoundTemplate  };
        case UPDATE_TABLE_STATE_TEMPLATE:
            return { ...state, tableTemplate: action.tableTemplate  };
        case UPDATE_SEARCH_TEMPLATE:
            return { ...state, searchTemplate: action.searchTemplate }   
        case UPDATE_SEARCH_CURRENT_PAGE_TEMPLATE:
            return { ...state, currentPageSearchTemplate: action.currentPageSearchTemplate }  
        case UPDATE_API_CALL_TEMPLATE:
            return { ...state, apiCallTemplate: action.apiCallTemplate }  
        default:
            return state;
    }
}


export default templatePageReducer;